import {
  GET_ACCOUNTS,
  GET_ACCOUNTS_FAIL,
  GET_ACCOUNTS_SUCCESS,
  ADD_NEW_ACCOUNT,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAIL,

  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_FAIL,

  DELETE_ACCOUNT,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAIL,

  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,

  // SEND INVITATION
  SEND_INVITATION,
  SEND_INVITATION_SUCCESS,
  SEND_INVITATION_FAIL,

  // RESEND INVITATION 
  RESEND_INVITATION,
  RESEND_INVITATION_SUCCESS,
  RESEND_INVITATION_FAIL,

  // ACCEPT INVITATION
  ACCEPT_INVITATION,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAIL,

  // RESEND INVITATION CODE
  RESEND_INVITATION_CODE,
  RESEND_INVITATION_CODE_SUCCESS,
  RESEND_INVITATION_CODE_FAIL,

  // CREATE PASSWORD
  CREATE_PASSWORD,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAIL,


  // LOCK ACCOUNT
  LOCK_ACCOUNT,
  LOCK_ACCOUNT_SUCCESS,
  LOCK_ACCOUNT_FAIL,

  // UNLOCK ACCOUNT
  UNLOCK_ACCOUNT,
  UNLOCK_ACCOUNT_SUCCESS,
  UNLOCK_ACCOUNT_FAIL,

  // ENABLE TWO FACTOR
  ENABLE_TWO_FACTOR,
  ENABLE_TWO_FACTOR_SUCCESS,
  ENABLE_TWO_FACTOR_FAIL,

  // DISABLE TWO FACTOR
  DISABLE_TWO_FACTOR,
  DISABLE_TWO_FACTOR_SUCCESS,
  DISABLE_TWO_FACTOR_FAIL,

  // VERIFY 2FA
  VERIFY_TWO_FACTOR,
  VERIFY_TWO_FACTOR_SUCCESS,
  VERIFY_TWO_FACTOR_FAIL,

  RESEND_TWO_FACTOR_CODE,
  RESEND_TWO_FACTOR_CODE_SUCCESS,
  RESEND_TWO_FACTOR_CODE_FAIL,


  

  


  
} from "./actionTypes";

export const getAccounts = () => ({
  type: GET_ACCOUNTS,
})

export const getAccountsSuccess = movieCatgeories => ({
  type: GET_ACCOUNTS_SUCCESS,
  payload: movieCatgeories,
})

export const getAccountsFail = error => ({
  type: GET_ACCOUNTS_FAIL,
  payload: error,
})

export const addNewAccount = data => ({
  type: ADD_NEW_ACCOUNT,
  payload: data,
})

export const addAccountSuccess = movieCatgeory => ({
  type: ADD_ACCOUNT_SUCCESS,
  payload: movieCatgeory,
})

export const addAccountFail = error => ({
  type: ADD_ACCOUNT_FAIL,
  payload: error,
})

export const updateAccount = movieCatgeory => ({
  type: UPDATE_ACCOUNT,
  payload: movieCatgeory,
})

export const updateAccountSuccess = movieCatgeory => ({
  type: UPDATE_ACCOUNT_SUCCESS,
  payload: movieCatgeory,
})

export const updateAccountFail = error => ({
  type: UPDATE_ACCOUNT_FAIL,
  payload: error,
})

// CHANGE PASSWORD
export const changePassword = payload => ({
  type: CHANGE_PASSWORD,
  payload: payload,
})

export const changePasswordSuccess = payload => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: payload,
})

export const changePasswordFail = error => ({
  type: CHANGE_PASSWORD_FAIL,
  payload: error,
})

export const deleteAccount = data => ({
  type: DELETE_ACCOUNT,
  payload: data,
})

export const deleteAccountSuccess = data => ({
  type: DELETE_ACCOUNT_SUCCESS,
  payload: data,
})

export const deleteAccountFail = error => ({
  type: DELETE_ACCOUNT_FAIL,
  payload: error,
})

// SEND INVITATION
export const sendInvitation = data => ({
  type: SEND_INVITATION,
  payload: data,
})

export const sendInvitationSuccess = data => ({
  type: SEND_INVITATION_SUCCESS,
  payload: data,
})

export const sendInvitationFail = error => ({
  type: SEND_INVITATION_FAIL,
  payload: error,
})

// RESEND INVITATION
export const resendInvitation = data => ({
  type: RESEND_INVITATION,
  payload: data,
})

export const resendInvitationSuccess = data => ({
  type: RESEND_INVITATION_SUCCESS,
  payload: data,
})

export const resendInvitationFail = error => ({
  type: RESEND_INVITATION_FAIL,
  payload: error,
})

// ACCEPT INVITATION
export const acceptInvitation = code => ({
  type: ACCEPT_INVITATION,
  payload: code,
})

export const acceptInvitationSuccess = response => ({
  type: ACCEPT_INVITATION_SUCCESS,
  payload: response,
})

export const acceptInvitationFail = error => ({
  type: ACCEPT_INVITATION_FAIL,
  payload: error,
})

// RESEND INVITATION CODE
export const resendInvitationCode = (token) => ({
    type: RESEND_INVITATION_CODE,
    payload: { token }
});

export const resendInvitationCodeSuccess = (token) => ({
    type: RESEND_INVITATION_CODE_SUCCESS,
    payload: { token }
});

export const resendInvitationCodeFail = (error) => ({
    type: RESEND_INVITATION_CODE_FAIL,
    payload: error,
});


// CREATE PASSWORD
export const createPassword = data => ({
  type: CREATE_PASSWORD,
  payload: data,
})

export const createPasswordSuccess = data => ({
  type: CREATE_PASSWORD_SUCCESS,
  payload: data,
})

export const createPasswordFail = error => ({
  type: CREATE_PASSWORD_FAIL,
  payload: error,
})


// LOCK ACCOUNT
export const lockAccount = (account) => ({
  type: LOCK_ACCOUNT,
  payload: account,
});

export const lockAccountSuccess = (account) => ({
  type: LOCK_ACCOUNT_SUCCESS,
  payload: account,
});

export const lockAccountFail = (error) => ({
  type: LOCK_ACCOUNT_FAIL,
  payload: error,
});

// UNLOCK ACCOUNT
export const unlockAccount = (account) => ({
  type: UNLOCK_ACCOUNT,
  payload: account,
});

export const unlockAccountSuccess = (account) => ({
  type: UNLOCK_ACCOUNT_SUCCESS,
  payload: account,
});

export const unlockAccountFail = (error) => ({
  type: UNLOCK_ACCOUNT_FAIL,
  payload: error,
});


// ENABLE TWO FACTOR
export const enableTwoFactor = () => ({
  type: ENABLE_TWO_FACTOR,
  //payload: account,
});

export const enableTwoFactorSuccess = (response) => ({
  type: ENABLE_TWO_FACTOR_SUCCESS,
  payload: response,
});

export const enableTwoFactorFail = (error) => ({
  type: ENABLE_TWO_FACTOR_FAIL,
  payload: error,
});


// DISABLE TWO FACTOR
export const disableTwoFactor = () => ({
  type: DISABLE_TWO_FACTOR,
  //payload: account,
});

export const disableTwoFactorSuccess = (response) => ({
  type: DISABLE_TWO_FACTOR_SUCCESS,
  payload: response,
});

export const disableTwoFactorFail = (error) => ({
  type: DISABLE_TWO_FACTOR_FAIL,
  payload: error,
});


// VERIFY 2FA
export const verifyTwoFactor = (payload) => ({
  type: VERIFY_TWO_FACTOR,
  payload,
});

export const verifyTwoFactorSuccess = (user) => ({
  type: VERIFY_TWO_FACTOR_SUCCESS,
  payload: user,
});

export const verifyTwoFactorFail = (error) => ({
  type: VERIFY_TWO_FACTOR_FAIL,
  payload: error,
});

// RESEND TWO FACTOR CODE
export const resendTwoFactorCode = (temp_token) => ({
    type: RESEND_TWO_FACTOR_CODE,
    payload: { temp_token }
});

export const resendTwoFactorCodeSuccess = (temp_token) => ({
    type: RESEND_TWO_FACTOR_CODE_SUCCESS,
    payload: { temp_token }
});

export const resendTwoFactorCodeFail = (error) => ({
    type: RESEND_TWO_FACTOR_CODE_FAIL,
    payload: error,
});
